import { CompanyRepository } from "core/repository";
import { BasePresenter } from "core/presenter";
import { fn } from "util";

class DataTablePresenter extends BasePresenter {
  initialState() {
    return {
      loading: true,
      filter: [],
      order: {
        field: "name",
        direction: "ASC"
      },
      content: [],
      errorable: {
        visible: false,
        content: ""
      },
      pagination: {
        perPage: 0,
        currentPage: 1,
        total: 0
      }
    };
  }

  async onStart() {
    this.doLoadResults();
  }

  async doLoadResults() {
    this.viewModel.loading = true;
    this.renewCancelToken();

    const repositoryResult = await CompanyRepository.getListOnline({
      order: [this.viewModel.order],
      pagination: {
        page: this.viewModel.pagination.currentPage,
        perPage: 25
      },
      filters: await this.getFilter()
    });

    if (repositoryResult.success) {
      this.viewModel.content = repositoryResult.data;
      this.viewModel.pagination = {
        ...this.viewModel.pagination,
        total: repositoryResult.total,
        perPage: repositoryResult.perPage
      };
    } else if (!repositoryResult.userCancelled) {
      this.sendNotification({
        type: "error",
        title: "Ocorreu um erro",
        content:
          "Não foi possível carregar os dados. Tente novamente mais tarde."
      });
    }

    this.viewModel.loading = false;
  }

  async getFilter() {
    const currentUser = await this.mRuntime.get("currentUser");

    return [
      ...this.viewModel.filter,
      {
        connector: "AND",
        field: "account_uuid",
        operation: "EQ",
        value: currentUser.account_uuid
      }
    ];
  }

  onFilterChange(fields) {
    const filter = [];

    if (!fn.isBlank(fields.cnpj)) {
      filter.push({
        connector: "AND",
        field: "fiscal_informations.cnpj",
        operation: "LIKE",
        value: fields.cnpj.replace(/\D/g, "")
      });
    }
    if (!fn.isBlank(fields.email)) {
      filter.push({
        connector: "AND",
        field: "email",
        operation: "LIKE",
        value: fields.email
      });
    }
    if (!fn.isBlank(fields.legal_name)) {
      filter.push({
        connector: "AND",
        field: "fiscal_informations.legal_name",
        operation: "LIKE",
        value: fields.legal_name
      });
    }
    if (!fn.isBlank(fields.name)) {
      filter.push({
        connector: "AND",
        field: "name",
        operation: "LIKE",
        value: fields.name
      });
    }
    if (!fn.isBlank(fields.phone)) {
      filter.push({
        connector: "AND",
        field: "phone",
        operation: "LIKE",
        value: fields.phone.replace(/\D/g, "")
      });
    }

    this.viewModel.filter = filter;
    this.doLoadResults();
  }

  onPageChange(page) {
    this.viewModel.pagination = {
      ...this.viewModel.pagination,
      currentPage: page
    };
    this.doLoadResults();
  }

  onOrderChange(field, direction) {
    this.viewModel.order = { field, direction };
    this.doLoadResults();
  }
}

export default DataTablePresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/data-table/data-table.presenter.js